






























































































































































import { Component, Prop, Provide, ProvideReactive, Vue, Watch, Ref } from "vue-property-decorator"
import { Getter, namespace } from "vuex-class"

import RecordAssignmentService from "../../../services/recordAssignmentService"

import { CasesPortalNames } from "@/views/new/Cases.vue"

import Header from "@/components/New/Cases/EditingCase/Header.vue"
import CaseToolbar from "./EditingCase/CaseToolbar.vue"
import Desktop from "./EditingCase/Desktop.vue"
import UserImage from "@/components/UserImage.vue"
import SkeletonLoader from "@/components/SkeletonLoader.vue"
import CaseSubheader from "./EditingCase/CaseSubheader.vue"

import { CaseDetails as CaseDetailsType, CaseUser, TemplateDetails, CaseField, CaseAudit } from "@/types"

import HubCaseService from "@/services/hubCaseService"

import api from "@/services/api"
import { CurrentUser } from "@/types/user"
import { CaseEvents } from "@/types/originatingEvents"
import { applyTemplate, updateCaseDetails } from "@/scripts/caseDetails"
import FileService from "@/services/file-service"
import { MapProvider } from "@/services/mapProvider"
import CaseFile from "@/types/caseFile"
import { CadenceInstance } from "@/types/cadence"
import { TenantFeatures } from "@/types/tenantFeatures"
import cloneDeep from "lodash/cloneDeep"
import { TriageTemplateChangeSetting } from "@/types/triage"
import { TenantSettingKeys } from "@/types/tenantSetting"
import { BModal } from "bootstrap-vue"
import { RecordUserAssignment } from "@/types/assignment"
import CaseAuditHistoryService from "@/../src/services/caseAuditHistoryService"
import PendingClosureModal from "./PendingClosureModal.vue"
import { AssignmentMergeType } from "@/types/timeManagement"
import { UserSettings, CaseCloseOption } from "@/types/userSettings"
import { DateTime } from "luxon"
import apiDefaultCache from "@/services/apiDefaultCache"
import CaseHubEventHandler from "./EditingCase/CaseHubEventHandler.vue"

const caseStore = namespace("cases")

enum CaseButtons {
	Merge = "merge",
	GenerateQr = "generate-qr",
	ChangeClosed = "change-close",
	SetSensitive = "make-sensitive",
	InsightHide = "hide-from-insights",
	Delete = "delete"
}

@Component({
	components: {
		"skeleton": SkeletonLoader,
		"case-header": Header,
		"toolbar": CaseToolbar,
		"desktop": Desktop,
		"user-image": UserImage,
		"subheader": CaseSubheader,
		"pending-closure-modal": PendingClosureModal,
		"case-hub-event-handler": CaseHubEventHandler
	}
})
export default class CaseDetails extends Vue {
	@ProvideReactive("hubCaseService") hubCaseService: HubCaseService = new HubCaseService()
	@Provide() caseAuditHistoryService: CaseAuditHistoryService = new CaseAuditHistoryService()

	@Provide("mapProvider") mapProvider: MapProvider = new MapProvider()
	@Provide("fileService") fileService: FileService = new FileService(this.caseFilesChanged)
	@Provide("recordAssignmentService") recordAssignmentService!: RecordAssignmentService

	@Ref() completeTriageConfirmModal!: BModal
	@Ref() private readonly caseHubEventHandler!: CaseHubEventHandler

	@Getter("getMe")
	public me!: CurrentUser
	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean
	@Getter getTenantSettings!: { [key: string]: any } | null

	@Getter("getUserSettings")
	public userSettings!: UserSettings

	@Getter("getCaseName") caseName!: string
	@Getter("getRecordName") recordName!: string

	@caseStore.Getter
	private getBlankCase!: () => CaseDetailsType

	@caseStore.Action
	public detailsLoad!: () => Promise<void>

	@caseStore.State
	public caseRefresh!: string | null

	@caseStore.Mutation
	private setCaseRefresh!: (refresh: boolean | null) => void

	@caseStore.Mutation
	private clearFieldsAwaitingUpdate!: () => void

	@caseStore.Mutation
	private removeFieldAwaitingUpdate!: (fieldId: string) => void

	@Prop({ default: null })
	caseNumber!: string | null

	@Prop({ default: () => null })
	createTemplateId!: string | null

	@Prop({ type: Boolean, default: false })
	borderless!: boolean

	@Prop({ type: Boolean, default: false })
	noTemplateChange!: boolean

	@Prop({ default: null })
	portalId!: string | null

	@Prop({ default: null })
	loadCase!: CaseDetailsType | null

	/* --- Constants References --- */

	private viewingUsersDisplayCount: number = 10
	private auditHistoryRefreshDebounceMs: number = 200

	/* --- Data --- */

	loading: boolean = false
	private caseLoadFailMessage: string = "";

	public currentCase: CaseDetailsType | null = null

	public currentCaseTemplate: TemplateDetails | null = null
	public caseEvents: CaseEvents | null = null
	public caseFiles: CaseFile[] = []
	public caseLoadFailed: boolean = false
	currentCaseCadenceInstance: CadenceInstance | null = null

	private auditHistoryRefreshTimeout: NodeJS.Timeout | null = null

	editingTitle = false
	makingClosedChanges = false
	closingCase = false
	creating = false
	createdCaseNumber: string | null = null
	TriageTemplateChangeSetting = TriageTemplateChangeSetting

	constructor () {
		super()
		this.recordAssignmentService = new RecordAssignmentService(this.getIsFeatureEnabled)
	}

	get footerRightPortal (): string {
		if (this.portalId) {
			return `${CasesPortalNames.FooterRight}-${this.portalId}`
		}
		return CasesPortalNames.FooterRight
	}

	get headerPortal (): string {
		if (this.portalId) {
			return `${CasesPortalNames.HeaderContent}-${this.portalId}`
		}
		return CasesPortalNames.HeaderContent
	}

	get subHeaderPortal (): string {
		if (this.portalId) {
			return `${CasesPortalNames.SubHeader}-${this.portalId}`
		}
		return CasesPortalNames.SubHeader
	}

	get canCreateCase (): boolean {
		if (!this.currentCaseTemplate) return false
		return !this.currentCaseTemplate.permissions!.case ||
			this.currentCaseTemplate.permissions!.case.edit.length === 0 ||
			this.currentCaseTemplate.permissions!.case.edit.some((e: any) => this.me.teams.some((mt: any) => mt.id === e.id))
	}

	get canCreateRecord (): boolean {
		if (!this.currentCaseTemplate || this.currentCaseTemplate.alwaysPromoted) return false
		return !this.currentCaseTemplate.permissions!.record ||
			this.currentCaseTemplate.permissions!.record.edit.length === 0 ||
			this.currentCaseTemplate.permissions!.record.edit.some((e: any) => this.me.teams.some((mt: any) => mt.id === e.id))
	}

	/**
	 * Case number to load
	 */
	get loadCaseNumber (): string | null {
		if (this.caseNumber) {
			return this.caseNumber
		}

		return this.$route && this.$route.params ? this.$route.params.caseNumber : null
	}

	get caseTitle () {
		if (this.currentCase && !this.currentCase.id &&
			this.titleTemplateEnabled) {
			return "Title set by template"
		}

		return this.currentCase?.title ?? "New Case"
	}
	set caseTitle (value: string) {
		if (this.currentCase!.title !== value) {
			this.currentCase!.title = value
		}
	}

	get canEditTitle () {
		return this.canEditCurrentCase && !!this.currentCase && (this.currentCaseTemplate || !this.currentCase.id) && !this.titleTemplateEnabled
	}

	get caseDeleted () {
		return !!this.currentCase?.deleted
	}

	public get caseCreationValid (): boolean {
		return !!this.currentCase &&
			!!this.currentCase.templateId &&
			(this.titleTemplateEnabled
				? true
				: (!!this.currentCase.title && this.currentCase.title.trim().length > 0))
	}

	/**
	 * Returns true if the user had Edit After Close Permissions
	 */
	public get editAfterClosePermissions (): boolean {
		if (this.currentCaseTemplate && this.currentCaseTemplate.editClosedPermissions && this.me) {
			return this.currentCaseTemplate.editClosedPermissions.length === 0 ||
					this.currentCaseTemplate.editClosedPermissions.some((teamId: any) => this.me.teams.find((team: any) => team.id === teamId))
		}
		return false
	}

	get hasEditCasePermissions () {
		if (!this.currentCase) {
			return false
		}

		if (!this.me) {
			return false
		}

		const casePermissions = this.currentCase.permissions
		if (casePermissions && casePermissions.edit && casePermissions.edit.length > 0) {
			if (!(this.me!.teams && casePermissions.edit.some(team => this.me!.teams.find((myTeam: any) => myTeam.id === team.id)))) {
				return false
			}
		}

		return true
	}

	get canEditCurrentCase () {
		if (!this.hasEditCasePermissions) {
			return false
		}

		if (this.currentCase!.isClosed) {
			return this.editAfterClosePermissions && this.makingClosedChanges
		}

		return true
	}

	get titleTemplateEnabled (): boolean {
		return !!this.currentCaseTemplate && !!this.currentCaseTemplate.enableTitleTemplate
	}

	get viewingCount (): number {
		return this.currentCase?.viewingUsers?.length ?? 0
	}

	get viewingUsersToDisplay () {
		let result = this.currentCase?.viewingUsers ?? []

		let currentUser = result.find(user => user.id === this.me?.id)
		if (currentUser) currentUser.name += " (you)"

		// only display the first X users
		if (result.length > this.viewingUsersDisplayCount) {
			result = result.slice(0, this.viewingUsersDisplayCount)
		}

		// ensure the current user is always shown in the main list
		if (currentUser && !result.includes(currentUser) && result.length > 0) {
			result[0] = currentUser
		} else if (currentUser) {
			// make sure the current user is the first in the list
			result = [currentUser, ...result.filter(user => user.id !== this.me?.id)]
		}

		return result
	}

	get viewingUsersOverflowNames (): string {
		let result = this.currentCase?.viewingUsers ?? []

		// remove the users we are already displaying
		result = result.filter(user => !this.viewingUsersToDisplay.includes(user))

		return result.map(user => user.name).join(", ")
	}

	@Watch("loadCaseNumber")
	private async onCaseNumberChanged (newCaseNumber: string | null) {
		await this.closeCaseConnection()

		this.currentCaseTemplate = null
		this.caseEvents = null
		this.caseFiles = []

		this.currentCase = null

		this.loading = true
		this.caseLoadFailed = false
		if (newCaseNumber) {
			try {
				this.clearFieldsAwaitingUpdate()
				this.recordAssignmentService.clear()
				this.caseAuditHistoryService.clear()
				if (newCaseNumber.toLowerCase() === "new") {
					await this.detailsLoad() // This needs to be awaited to load status / severity list
					const newCase = this.getBlankCase()
					if (this.createTemplateId) {
						newCase.templateId = this.createTemplateId
					}
					this.currentCase = newCase
					this.fileService.caseId = null
				} else {
					this.currentCase = await api.caseDetails(newCaseNumber)
					this.recordAssignmentService.load(this.currentCase, this.getIsFeatureEnabled)
					this.caseAuditHistoryService.load(this.currentCase)
					this.fileService.caseId = this.currentCase.id!
					await Promise.all([this.detailsLoad(), this.establishCaseConnection(), this.caseFilesLoad()])
				}

				if (this.currentCase && this.currentCase.templateId) {
					this.currentCaseTemplate = await this.fetchTemplate(this.currentCase.templateId)
				}

				if ((!this.currentCase.id) && (!this.currentCaseTemplate || !this.currentCaseTemplate.enableTitleTemplate)) {
					this.editingTitle = true
				}

				// Initialize 'oldValue' property to prevent redundant Field updates on first focus loss.
				if (this.currentCase.fields) {
					Object.values(this.currentCase.fields).forEach(field => {
						if (field.oldValue === undefined) {
							field.oldValue = field.value
						}
					})
				}

				// Initialize 'oldValue' property to prevent redundant Field updates on first focus loss.
				if (this.currentCase.fields) {
					Object.values(this.currentCase.fields).forEach(field => {
						if (field.oldValue === undefined) {
							field.oldValue = field.value
						}
					})
				}

				this.$emit("caseLoaded", this.currentCase)
			} catch (err) {
				console.error(err)
				this.caseLoadFailed = true
				if (err === "You do not have permission") {
					this.caseLoadFailMessage = "You do not have permission to view this " + this.caseName + "."
				} else {
					this.caseLoadFailMessage = "Unable to load requested " + this.recordName + "."
				}
			}
		}

		await this.fetchCadenceInstance()
		this.loading = false
	}

	@Watch("caseRefresh")
	onCaseRefreshChanged (newRefresh: boolean | null) {
		console.log("refresh changed")
		if (newRefresh) {
			this.onCaseNumberChanged(this.currentCase?.caseNumber!)
			this.setCaseRefresh(false)
		}
	}

	@Watch("valid")
	onValidChanged (newValue: boolean) {
		this.$emit("validChanged", newValue)
	}

	@Watch("currentCase.templateId")
	async currentCaseTemplateIdChanged (newValue: string | null) {
		if (!newValue) {
			this.currentCaseTemplate = null
			return
		} else if (newValue === this.currentCaseTemplate?.id) {
			return
		}

		const newTemplate = await this.fetchTemplate(newValue)
		this.currentCaseTemplate = newTemplate
	}

	@Watch("lastUpdated")
	private lastUpdatedChanged (newValue: string | null, oldValue: string | null): void {
		const newDateTime = newValue ? DateTime.fromISO(newValue) : null
		const oldDateTime = oldValue ? DateTime.fromISO(oldValue) : null

		// compare epoch time as date strings sometimes get truncated on save
		if (newDateTime?.toMillis() !== oldDateTime?.toMillis()) {
			// debounce the refresh to prevent multiple refreshes on rapid updates
			// (e.g. calculated field cascade updates)
			if (this.auditHistoryRefreshTimeout) {
				clearTimeout(this.auditHistoryRefreshTimeout)
			}

			this.auditHistoryRefreshTimeout =
				setTimeout(() => this.caseAuditHistoryService.refresh(), this.auditHistoryRefreshDebounceMs)
		}
	}

	@Watch("currentCase.isClosed")
	private async caseIsClosedChanged (isClosed: boolean) {
		if (this.closingCase && isClosed) {
			const caseClosingAction = this.userSettings?.settings?.caseClose || CaseCloseOption.RedirectToDashboard
			if (caseClosingAction === CaseCloseOption.RedirectToDashboard) {
				await this.redirectAfterClose()
			} else {
				setTimeout(() => { // Leaving time for cadences to be updated before refreshing.
					this.setCaseRefresh(true)
				}, 1000)
			}

			this.closingCase = false
		}
	}

	async mounted () {
		if (this.loadCase) {
			this.currentCase = this.loadCase
			this.recordAssignmentService.load(this.currentCase, this.getIsFeatureEnabled)
			await Promise.all([this.detailsLoad(), this.establishCaseConnection(), this.caseFilesLoad()])
			if (this.currentCase.templateId) {
				this.currentCaseTemplate = await this.fetchTemplate(this.currentCase.templateId)
			}
		} else {
			await this.onCaseNumberChanged(this.loadCaseNumber)
		}
		if (this.createTemplateId) {
			await this.templateChanged(this.createTemplateId)
		}

		await this.fetchCadenceInstance()
	}

	beforeDestroy () {
		this.closeCaseConnection()
	}

	private async establishCaseConnection () {
		const caseDetails = this.currentCase

		if (caseDetails && caseDetails.id) {
			const connection = await this.hubCaseService.openConnection(caseDetails.id!)
			if (connection) {
				this.caseHubEventHandler.handleHubRecordEvents(connection)
			}
		}
	}

	/**
	 * Re-fetches the cadence instance if the changed fields include/involve a running total section field
	 * in order to get any updated running total values
	 **/
	private updateCadenceRunningTotalsIfRequired (updatedFields: { [fieldId: string]: CaseField }, existingFields: { [fieldId: string]: CaseField }): void {
		if (!this.currentCaseTemplate?.cadenceDetails?.runningTotalSectionFields) {
			return
		}
		const cadenceTotalDataTypes = ["number", "calculated", "user-role"]

		// we currently only care about the value itself or the totalTime property in the case of a user-role field
		const modifiedFields = Object.keys(updatedFields).filter(fieldId =>
			cadenceTotalDataTypes.includes(updatedFields[fieldId]!.field!.dataType!) && (
				updatedFields[fieldId]?.value !== existingFields[fieldId]?.value ||
				updatedFields[fieldId]?.value?.totalTime !== existingFields[fieldId]?.value?.totalTime
			)
		).map(fieldId => updatedFields[fieldId])

		const runningTotalFields = Object.values(this.currentCaseTemplate!.cadenceDetails.runningTotalSectionFields)
			.flat().distinct()

		for (const modifiedField of modifiedFields) {
			if (modifiedField.field?.id && runningTotalFields.includes(modifiedField.field.id)) {
				this.fetchCadenceInstance()
				return
			}

			const dependentCalculatedFields = this.currentCaseTemplate?.fields.filter(field =>
				field.field.dataType === "calculated" && field.field.extensions?.fields &&
				field.field.extensions.fields.includes(modifiedField.field!.id!)) ?? []

			if (dependentCalculatedFields.length > 0) {
				// If there are any calculated fields depending on the changed field, simply re-fetch the
				// running totals as it could be a chain of calculated fields that lead to a running total field
				this.fetchCadenceInstance()
				return
			}

			const dependentDataItemFields = modifiedField.field?.extensions?.dataListField
				? this.currentCaseTemplate?.fields.filter(field =>
					(field.field.dataType === "number" || field.field.dataType === "calculated") &&
					field.field.extensions?.dataListField &&
					field.field.extensions.dataListField === modifiedField.field!.extensions!.dataListField) ?? []
				: []

			if (dependentDataItemFields.length > 0) {
				// If there are any fields dependent on the same data items as the changed field, simply re-fetch
				// the running totals as it could be a chain of fields that lead to a running total field
				this.fetchCadenceInstance()
				return
			}
		}
	}

	private caseChanged () {
		if (this.currentCase && this.currentCase.id) {
			api.saveCase(this.currentCase)
		}
	}

	private async closeCaseConnection () {
		if (this.hubCaseService) {
			this.hubCaseService.closeConnection()
		}
	}

	private setEvents (caseEvents: CaseEvents) {
		if (!!caseEvents && !!caseEvents.originatingEvents) {
			caseEvents.originatingEvents.forEach(event => {
				if (event.keyEntries) {
					event.keyEntries.sortBy("created")
				}
			})
		}

		this.caseEvents = caseEvents
	}

	private async templateChanged (templateId: string | null) {
		if (templateId) {
			this.currentCaseTemplate = await this.fetchTemplate(templateId)

			if (this.currentCase && this.currentCaseTemplate) {
				applyTemplate(this.currentCase, this.currentCaseTemplate!)

				if (!this.currentCase.id && this.currentCaseTemplate.enableTitleTemplate) {
					this.editingTitle = false
				}
			}
		} else {
			this.currentCaseTemplate = null
		}
	}

	private async fetchTemplate (templateId: string) {
		return apiDefaultCache.templateDetails(templateId)
	}

	/**
	 * Event handler for when files on the case have been updated.
	 * If the case is being created, this will then create the case when done.
	 */
	public caseFilesChanged () {
		if (this.creating) {
			this.creating = false
			if (this.caseNumber) {
				this.$emit("caseCreated", {
					caseNumber: this.createdCaseNumber!,
					...this.currentCase
				})
			} else {
				this.$router.replace({ name: "case", params: { caseNumber: this.createdCaseNumber! } })
			}
		} else {
			this.caseFilesLoad()
		}
	}

	private async caseFilesLoad () {
		if (this.currentCase && this.currentCase.id) {
			this.caseFiles = await api.caseFiles(this.currentCase.id)
		}
	}

	public async createNew (isCase: boolean) {
		if (this.creating || !this.currentCase) return

		this.creating = true

		try {
			this.currentCase.isCase = isCase
			const created = await api.saveCase(this.currentCase)

			if (this.fileService.uploadFiles.length === 0) {
				if (this.caseNumber) {
					this.$emit("caseCreated", created)
				} else {
					await this.$router.replace({ name: "case", params: { caseNumber: created?.caseNumber ?? "" } })
				}

				this.creating = false
			} else {
				this.createdCaseNumber = created.caseNumber
				await this.fileService.uploadPendingFiles(created.id!)
			}
		} catch (error) {
			console.error(error)
			this.creating = false
		}
	}

	async closeCase () {
		if (this.currentCase) {
			if (this.closingCase) return

			this.closingCase = true
			try {
				await api.close(this.currentCase.id!)
			} catch (exception) {
				const missingFieldErrorPrefix = `Missing ${this.currentCase.isCase ? this.caseName : this.recordName} Field values - `
				const missingActionErrorPrefix = `Missing ${this.currentCase.isCase ? this.caseName : this.recordName} Actions - `
				let exceptionString = (exception as any).error as string
				if (exceptionString && exceptionString.length && exceptionString.startsWith(missingFieldErrorPrefix)) {
					// Failed due to missing fields
					let missingFieldsListString = this.getTitlesFromErrorMessage(exceptionString.substring(missingFieldErrorPrefix.length).trim())

					this.$bvToast.toast(`The case could not be closed because the following field(s) must be set: ${missingFieldsListString}`, {
						title: `Failed to close ${this.currentCase.isCase ? this.caseName : this.recordName}`,
						variant: "danger",
						solid: true,
						autoHideDelay: 10000000
					})
				} else if (exceptionString && exceptionString.length && exceptionString.startsWith(missingActionErrorPrefix)) {
					// Failed due to missing actions
					let missingActionsListString = this.getTitlesFromErrorMessage(exceptionString.substring(missingActionErrorPrefix.length).trim())

					this.$bvToast.toast(`The case could not be closed because the following field(s) must be set: ${missingActionsListString}`, {
						title: `Failed to close ${this.currentCase.isCase ? this.caseName : this.recordName}`,
						variant: "danger",
						solid: true,
						autoHideDelay: 10000000
					})
				} else {
					this.$bvToast.toast(exception as string, {
						title: `Failed to close ${this.currentCase.isCase ? this.caseName : this.recordName}`,
						variant: "danger",
						solid: true,
						autoHideDelay: 10000000
					})
				}
			} finally {
				this.closingCase = false
			}
		}
	}

	async redirectAfterClose () {
		if (this.currentCase && this.currentCase.isClosed) {
			if (!this.caseNumber) {
				await this.$router.push("/cases-new")
			} else {
				this.$emit("caseClosed")
			}
		}
	}

	async cancelCloseCase () {
		if (this.currentCase && this.currentCase.pendingClosure) {
			await api.cancelPendingClosure(this.currentCase.id!)
		}
	}

	public async markSensitive () {
		if (this.currentCase?.id) {
			try {
				await api.markAsSensitive(this.currentCase.id)
				this.currentCase.isSensitive = true
			} catch (err) {
				console.log(err)
			}
		}
	}

	public async promoteToCase () {
		if (!this.currentCase?.id) {
			return
		}
		await api.recordToCase(this.currentCase.id)
	}

	private cadenceRunningTotalsFeatureIsEnabled (): boolean {
		return this.getIsFeatureEnabled(TenantFeatures.CadenceRunningTotals)
	}

	async fetchCadenceInstance () {
		if (!this.cadenceRunningTotalsFeatureIsEnabled) {
			return
		}

		if (this.currentCase && this.currentCase.id && this.currentCase.cadenceNumber) {
			let cadenceInstance
			try {
				cadenceInstance = await api.cadenceInstance(this.currentCase.cadenceNumber)
			} catch (err) {
				console.error("The cadence instance could not be fetched")
			}

			Vue.set(this, "currentCaseCadenceInstance", cadenceInstance ?? null)
		} else {
			Vue.set(this, "currentCaseCadenceInstance", null)
		}
	}

	get tenantTriageTemplateChangeSetting (): TriageTemplateChangeSetting {
		const tenantSettings = this.getTenantSettings ?? {}
		const triageChangeSetting = tenantSettings[TenantSettingKeys.TriageTemplateChange]
		if (triageChangeSetting) {
			return triageChangeSetting
		} else {
			return TriageTemplateChangeSetting.Disallow
		}
	}

	completeTriage () {
		if (!this.currentCase) return
		api.completeTriage(this.currentCase.id!)
	}

	private get lastUpdated (): string {
		if (this.currentCase && this.currentCase.id && this.currentCase.lastUpdated) {
			return this.currentCase.lastUpdated
		}
		return ""
	}

	/**
	 * Extracts titles from Id Title pairs in error message for CloseCase api call and returns a the titles as an array
	 * @param errorMessageString: Error message string of format "(Id: abc, Title: xyz) (Id: def, Title: uvw)"
	 */
	private getTitlesFromErrorMessage (errorMessageString: string): string[] {
		// Extract all Title values
		const titleRegex = /Title:\s*([^)]*)/g // Matches "Title: [Field Title]" within each field
		const matches = []
		let match

		while ((match = titleRegex.exec(errorMessageString)) !== null) {
			matches.push(match[1].trim()) // Add the extracted Title to the list
		}

		return matches
	}

	private onHubCaseUpdated (updatedRecord: CaseDetailsType, existingFields: { [key: string]: CaseField }) {
		this.updateCadenceRunningTotalsIfRequired(updatedRecord.fields, existingFields)
	}

	private onHubCaseClosing () {
		this.closingCase = true
	}
}
